function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "59.526%",
  x2: "59.526%",
  y1: "111.335%",
  y2: "28.082%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#01AAC6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#33B6DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#33B6DC"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M217.306 204.376l-52.89-52.89c13.11-15.984 21.013-36.457 21.013-58.772C185.429 41.531 143.898 0 92.714 0 41.486 0 0 41.53 0 92.714s41.486 92.715 92.714 92.715c22.315 0 42.743-7.858 58.727-20.968l52.89 52.845a9.16 9.16 0 0 0 12.975 0c3.592-3.547 3.592-9.384 0-12.93zm-124.592-37.4c-40.992 0-74.306-33.315-74.306-74.262s33.314-74.306 74.306-74.306c40.947 0 74.306 33.36 74.306 74.306 0 40.947-33.359 74.262-74.306 74.262z"
});

var SvgMagnifyingGlass = function SvgMagnifyingGlass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagnifyingGlass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magnifyingGlass.c129fa3e.svg";
export { ForwardRef as ReactComponent };